module.exports = __webpack_public_path__ + "img/10.4543c654.jpg";